<template>
  <div class="container" style="margin-top:43px;">
    <div>
      <div class="fwmok">
        <a href="http://yanshi.xuexiao.com.cn/">
          <img src="/static/img/icon_jigouchaxun.png"/>
          <p>考试中心</p>
        </a>
          
      </div>
      <div class="fwmok fwmok1" style="margin-left:39px">
        <router-link :to="zhengcpath">
          <img src="/static/img/icon_liuyanzixun.png"/>
          <p>政策法规</p>
        </router-link>
      </div>
      <div class="fwmok fwmok2" style="margin-left:39px">
        <router-link :to="querypath">
          <img src="/static/img/icon_peixunzhegnshu.png"/>
          <p>证书查询</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {
    plates: Array,
    platename: String,
  },
  components: {},
  data() {
    return {
      articles: [],
      plate: {},
      jfplate:{},
      global,
      zhengcpath:'',
      querypath:global.isPhone()?'/inqCertM':'/inqCert'
    };
  },
  created(){
    for (let j = 0; j < this.plates.length; j++) {
      if(this.plates[j].name == '政策法规')
      {
        this.zhengcpath = "/news/views/" + this.plates[j]._id;
        break;
      }
    }
  },
  mounted() {
    
  },
  methods: {
    getDay(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return now.getDate();
    },
    getMonth(article) {
      let time =
        (article.addtime && article.addtime.replace(/-/g, "/")) ||
        article.createdAt;
      let now = new Date(time);
      return `${now.getMonth() + 1}`;
    },
  },
};
</script>
<style scoped>
.title{
      font-size: 26px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #3F4CAD;
    line-height: 22px;
} 
.fwmok{
  width: 374px;
  height: 94px;
  background-image: linear-gradient(to right , #ff2c2c, #f17878);
  border-radius: 11px;
  display: inline-block;
}
.fwmok1{
  background-image: linear-gradient(to right , #d0a233, #ebc473);
}
.fwmok2{
  background-image: linear-gradient(to right , #6a71e6, #9497fd);
}
.fwmok img{
display: block;
    padding-top: 21px;
    float: left;
    margin-left: 58px;
        margin-right: 23px;
}
.fwmok p{
  font-size: 34px;
font-family: PingFang SC;
font-weight: bold;
color: #fff;
text-align: left;
    margin-top: 30px;
    letter-spacing: 8px;
    margin-bottom: 8px;
}
.fwmok span{
  
color: #999999;
font-size: 12px;
}
.zhbtn_left{
  width: 119px;
  height: 29px;
  border: 1px solid #E0E0E0;
  margin-left: 14px;
  margin-top: 13px;
  font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
}
.zhbtn_left:hover{ 
  cursor:pointer;
  background: #3d55a7;
    color: #fff;
}
.zhbtn_right{
  width: 119px;
  height: 29px;
  border: 1px solid #E0E0E0;
  margin-left: 18px;
  margin-top: 13px;
  font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #666666;
}
.zhbtn_right:hover{ 
  cursor:pointer;
  background: #3d55a7;
    color: #fff;
}
</style>
